import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { Input } from "@repo/ui/components/Base/Input";
import { Button } from "@repo/ui/components/Base/Button";
import { AuthContext } from "@/providers";
import { useState } from "react";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
});

export const ResetPasswordForm = () => {
  const [, send] = AuthContext.useActor();
  const [resetSent, setResetSent] = useState(false);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      send({ type: "RESETPASSWORD", data: values });
      setResetSent(true);
    },
  });

  return (
    <div className="w-full md:w-96">
      <form onSubmit={formik.handleSubmit} className="gap-y-2 w-full">
        <Input
          id="email"
          name="email"
          label="Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          errorMessage={
            formik.touched.email && formik.errors.email
              ? formik.errors.email
              : ""
          }
        />
        <div className="flex flex-row justify-between mt-4">
          <Button
            variant="ghost"
            type="button"
            onClick={() => navigate("/auth/register")}
          >
            Sign Up
          </Button>

          <Button
            variant="ghost"
            type="button"
            onClick={() => navigate("/auth/login")}
          >
            Back to Login
          </Button>
        </div>
        {resetSent ? (
          <div className="text-sm text-center">
            <p>An email has been sent to: </p>

            <pre>{formik.values.email}</pre>

            <p>
              Follow the instructions in the email then return to the login
              page.
            </p>
          </div>
        ) : (
          <div className="mt-2">
            <Button variant="default" type="submit" className="w-full">
              Request Password Reset
            </Button>
          </div>
        )}
      </form>
    </div>
  );
};
